<ng-container *ngIf="lottoId == 48">
  <!-- <div class="timer timer-cash relative">
    <app-countdown></app-countdown>
  </div> -->
</ng-container>
